import React from 'react';
import { GoalEmployee, GoalTeam, GoalType } from '../types';
import { getGoalTypeStr } from '../translations';

type Props = {
  goalType: GoalType;
  goalEmployee?: GoalEmployee; // undefined if type team or company
  goalTeam?: GoalTeam;
};

export const GoalInlineLabels: React.FC<React.PropsWithChildren<Props>> = ({
  goalType,
  goalEmployee,
  goalTeam,
}) => {
  return (
    <>
      <span className="text-muted small">({getGoalTypeStr(goalType)})</span>
      {goalTeam && <i className="fs-5">{goalTeam.name}</i>}
      {goalEmployee && <i className="fs-5">{goalEmployee.name}</i>}
    </>
  );
};
